import { queryOptions } from "@tanstack/react-query";
import { getObjectSettings } from "./get-object-settings";

export const objectQueries = {
  rootKey: () => ["object"],

  getObjectSettings: ({ projectId }: { projectId: string }) =>
    queryOptions({
      queryKey: [...objectQueries.rootKey(), "getObjectSettings", projectId],
      queryFn: () => getObjectSettings({ projectId }),
    }),

  getObject: ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    projectId: _projectId,
    objectId,
  }: {
    projectId: string;
    objectId: string;
  }) =>
    queryOptions({
      // TODO: добавить projectId при рефакторинге GET object
      queryKey: [...objectQueries.rootKey(), objectId],
    }),
};
